import React from 'react';

import { updateQueryString } from '../../services/services';

import { T } from '../../../../common/locale/translate';
import { urls } from '../../services/urls';

export default class OfferLocationHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      region: { name: '' },
      country: { name: '' },
      city: props.city
    };
  }

  componentWillMount = () => {
    if (document && this.props.region_id && this.props.regions) {
      this.setDestinations();
    }
  };

  componentWillReceiveProps = nextProps => {
    if (typeof nextProps.regions !== 'undefined') {
      this.setDestinations();
    }
  };

  render = () => (
    <span className="category">
      {this.state.country.name && (
        <a
          href={this.urlFor('country')}
          title={`${T('offers')} ${this.state.country.name}`}
        >
          {`${this.state.country.name}${
            this.state.region.name || this.props.city ? ', ' : ''
          }`}
        </a>
      )}
      {this.state.region &&
        this.state.region.name && (
          <a
            href={this.urlFor('region')}
            title={`${T('offers')} ${this.state.region.name}`}
          >
            {`${this.state.region.name}${this.props.city ? ', ' : ''}`}
          </a>
        )}
      {this.props.city && <span>{this.props.city}</span>}
    </span>
  );

  urlFor = destination => {
    let names = [
      urls.offer_types_list[this.props.offer_type],
      this.state.country.slug,
      destination === 'region' ? this.state.region.slug : null
    ];
    let cleanArray = [];
    names.forEach(element => {
      if (element) {
        cleanArray.push(element);
      }
    });
    if (window && window.location.search) {
      let url = window.location.search;
      url = updateQueryString('regions', null, url);
      url = updateQueryString('offer_type', null, url);
      return `${cleanArray.join('/')}${url}`;
    }
    return cleanArray.join('/');
  };

  setDestinations = () => {
    let region = this.props.regions
      ? this.props.regions[this.props.region_id]
      : {};
    if (region && region.parent) {
      this.setState({
        region: region,
        country: this.props.regions[region.parent]
      });
    } else {
      this.setState({ region: region });
    }
  };
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/offer-location-header.js